export default __webpack_public_path__ + "static/media/waves.455209d2ec3f73d726e6f83ea0d05afe.svg";